import React from "react";

/**
 * Componente que representa el trigger que activa el componente expandible.
 * @param {Object} props - Propiedades del componente `Trigger`.
 * @param {ReactNode} props.children - Elementos secundarios renderizados dentro del trigger.
 * @returns {JSX.Element} Elemento JSX que representa el componente `Trigger`.
 */
export const Trigger = ({ children }) => {
	return <div className="button">{children}</div>;
};

